import ls from 'localstorage-slim';
import React from 'react';
import { useSelector } from 'react-redux';
import useDeviceBreakpoint from '../../../hooks/useDeviceBreakpoint';
import useThemeHook from '../../../hooks/useThemeHook';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import OldButton from '../../b2b/components/button/button';
import Contact from '../contact/contact';
import Header from '../header/header';
import { ReactComponent as CancelledSvg } from '/src/assets/svg/lease-application-cancel.svg';
import { ReactComponent as CancelledSmallSvg } from '/src/assets/svg/small_error.svg';

const InvalidOfferErrorPage: React.FC = () => {
  useDeviceBreakpoint();
  useThemeHook();

  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <CancelledSmallSvg className='status-svg' />
      )}
      <div>Dein Angebot konnte leider nicht geladen werden</div>
    </>
  );

  const getSubHeading = () => {
    return 'Aufgrund eines technischen Fehlers kann dein Leasingantrag aktuell nicht fortgeführt werden.';
  };

  // Get previous URL from local storage, if not available, fallback to the default mobility portal URL from environment variables
  const mobilityPortalUrl = ls.get('mobilityPortalUrl');
  const backUrl = (mobilityPortalUrl as string)
    ? (mobilityPortalUrl as string)
    : import.meta.env.VITE_MOPO_URL;

  return (
    <>
      <Header />
      <Layout
        heading={headline}
        subHeading={getSubHeading()}
        hasFullSize={true}
        className='status-overview grid'
        style={{ gridTemplateRows: '15% 60%' }}
      >
        <div
          className='half-half-columns cancelled top-36'
          style={{ alignItems: 'start' }}
        >
          {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
            <CancelledSvg className='status-svg' />
          )}
          <div className='flex flex-col gap-4'>
            <div className='content-bold'>Was du jetzt tun kannst</div>

            <ArrowList
              className='dark-grey content-normal'
              list={[
                'Über den Button gelangst du zurück zu deinem ausgewählten Angebot. Dort kannst du den Leasingvorgang erneut starten.',
              ]}
            />

            <div className='content-bold'>Dein Konto bleibt erhalten</div>
            <ArrowList
              className='dark-grey content-normal'
              list={[
                'Deine Registrierung bleibt bestehen. Du kannst dich ganz einfach mit deinen Daten anmelden.',
              ]}
            />
            <OldButton
              type='button'
              onClick={() => window.open(backUrl, '_self')}
              style={{
                width: '100%',
                marginTop: '18px',
                marginBottom: '18px',
              }}
            >
              {mobilityPortalUrl ? (
                <span className='content-bold text-base!'>
                  Zurück zum Angebot
                </span>
              ) : (
                <span className='content-bold text-base!'>
                  Zur Fahrzeugsuche
                </span>
              )}
            </OldButton>

            <Contact />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default InvalidOfferErrorPage;
